import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { Icon, LinkContainer } from "components/common";
import { NavDropdown, MenuItem } from "components/bootstrap";
import Routes from "routing/Routes";
import useCurrentUser from "hooks/useCurrentUser";
import Menu from "components/bootstrap/Menu";
import useLogout from "hooks/useLogout";
import NavIcon from "components/navigation/NavIcon";
import UserPreferencesContext from "contexts/UserPreferencesContext";
import { availableLanguages, getLanguage } from "components/users/languages/Languages";
import LanguageLabel from "components/users/languages/LanguageLabel";
import applyLanguage from "util/applyLanguage";
import ThemeModeToggle from "./ThemeModeToggle";
const FullName = styled.span`
  text-transform: uppercase;
  font-weight: 700;
`;
const LanguageRow = styled.span(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacings.xs};
    min-width: 220px;
  `
);
const CurrentLanguage = styled.span(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacings.xxs};
    margin-left: auto;
    color: ${theme.colors.text.secondary};
  `
);
const UserMenu = () => {
  const { fullName, readOnly, id: userId } = useCurrentUser();
  const { language } = useContext(UserPreferencesContext);
  const route = readOnly ? Routes.SYSTEM.USERS.show(userId) : Routes.SYSTEM.USERS.edit(userId);
  const { t, i18n } = useTranslation("navigation");
  const label = readOnly ? t("user_menu.show_profile") : t("user_menu.edit_profile");
  const onLogoutClicked = useLogout();
  const currentLanguage = readOnly ? i18n.language : language;
  const onSelectLanguage = (code) => {
    applyLanguage(code).catch(() => {
    });
  };
  return /* @__PURE__ */ React.createElement(NavDropdown, { title: /* @__PURE__ */ React.createElement(NavIcon, { type: "user_menu" }), hoverTitle: t("user_menu.title", { name: fullName }), noCaret: true }, /* @__PURE__ */ React.createElement(Menu.Label, null, /* @__PURE__ */ React.createElement(FullName, null, fullName)), /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), /* @__PURE__ */ React.createElement(Menu.Label, null, /* @__PURE__ */ React.createElement(ThemeModeToggle, null)), /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), readOnly ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Menu.Label, null, t("user_menu.language")), availableLanguages().map(({ code }) => /* @__PURE__ */ React.createElement(MenuItem, { key: code, active: code === currentLanguage, onClick: () => onSelectLanguage(code) }, /* @__PURE__ */ React.createElement(LanguageLabel, { language: getLanguage(code), showBeta: true })))) : /* @__PURE__ */ React.createElement(LinkContainer, { to: route }, /* @__PURE__ */ React.createElement(MenuItem, { icon: "translate" }, /* @__PURE__ */ React.createElement(LanguageRow, null, t("user_menu.language"), /* @__PURE__ */ React.createElement(CurrentLanguage, null, /* @__PURE__ */ React.createElement(LanguageLabel, { language: getLanguage(currentLanguage) }), /* @__PURE__ */ React.createElement(Icon, { name: "chevron_right" }))))), /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), /* @__PURE__ */ React.createElement(LinkContainer, { to: route }, /* @__PURE__ */ React.createElement(MenuItem, null, label)), /* @__PURE__ */ React.createElement(MenuItem, { onClick: onLogoutClicked, icon: "logout" }, t("user_menu.log_out")));
};
export default UserMenu;
